import Heading from "components/Heading";
import React, { useEffect, useState } from "react";
import {
  Col, Container, Row
} from "reactstrap";
import { errorHandler } from "utils/Api";
import PackageAdviseNoticeOffCanvas from "components/OffCanvas/PackageAdviseNoticeOffCanvas";
import { getPOBoxByUser } from "api/POBoxApi";
import { getUserData } from "utils/Session";
import DeleteModal from "components/DeleteModal";
import { deletePackage } from "api/PackagesApi";
import { showAlert } from "utils/Alert";
// import styles from "./style.module.scss";
import UserPackagesTable from "components/UserPackagesTable";
import AnimatedTabs from "components/AnimatedTabs";
import { MOVEMENT_STATUS } from "utils/Constants";
import { deleteWarehousePrealert } from "api/WarehousePrealertApi";

const UserPackages = props => {
  const [poBox, setPoBox] = useState();
  const [packageData, setPackageData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [toDeleteBox, setToDeleteBox] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetchPOBox();
  }, []);

  const fetchPOBox = async () => {
    const userData = await getUserData();
    getPOBoxByUser(userData).then((r) => {
      setPoBox(r);
      setIsLoading(false);
    }).catch((e) => {
      errorHandler(e, "Fetch PO Box Data")
    });
  }

  const toogleModal = (e) => {
    setIsModalOpen(!isModalOpen);
    if (isModalOpen) {
      setToDeleteBox({});
    }
  }

  const deleteBox = (box) => {
    setIsLoading(true);
    deletePackage(box)
      .then(async (r) => {
        showAlert("success", `El paquete #${box.secuencia} fue eliminado correctamente`);
        deleteWarehousePrealert(r)
        toogleModal();
      }).catch(e => {
        errorHandler(e);
        showAlert("danger", `No fue posible eliminar el File #${box.secuencia}`);
      })
      .finally(() => fetchPOBox());
  }

  const showDeleteConfirm = (box) => {
    setToDeleteBox(box);
    toogleModal();
  }

  const editPackage = (box) => {
    setPackageData({ ...box });
  }

  const onPackageSave = () => {
    fetchPOBox();
  }

  const getActiveBoxes = () => {
    if (poBox && poBox.boxes && poBox.boxes.items) {
      return poBox.boxes.items.filter(b => {
        if (b.cargoMovement == null) {
          return true;
        } else {
          return b.cargoMovement.status !== MOVEMENT_STATUS.deliveried;
        }
      });
    } else {
      return [];
    }
  }

  const getDeliveryBoxes = () => {
    if (poBox && poBox.boxes && poBox.boxes.items) {
      return poBox.boxes.items.filter(b => {
        return b.cargoMovement && b.cargoMovement.status === MOVEMENT_STATUS.deliveried;
      });
    } else {
      return [];
    }
  }

  return (
    <>
      <Heading headingLevel="h2" className="pt-4" label="Lista de Paquetes" sticky >
        <Col sm={2}>
          <PackageAdviseNoticeOffCanvas
            className="float-end"
            btnColor="primary"
            adviseData={packageData}
            poBox={poBox}
            onSave={onPackageSave}>
            Crear Prealerta
          </PackageAdviseNoticeOffCanvas>
        </Col>
      </Heading>
      <Container>
        <Row>
          <Col>
            <AnimatedTabs
              tabsLabels={["En Transito", "Entregados"]}
            >
              <div>
                <Row>
                  <Col sm="12">
                    <UserPackagesTable
                      isLoading={isLoading}
                      packages={getActiveBoxes()}
                      onPackageEdit={(box) => editPackage(box)}
                      onPackageDelete={(box => showDeleteConfirm(box))}
                    />
                  </Col>
                </Row>
              </div>
              <div>
                <Row>
                  <Col sm="12">
                    <UserPackagesTable
                      isLoading={isLoading}
                      packages={getDeliveryBoxes()}
                      onPackageEdit={(box) => editPackage(box)}
                      onPackageDelete={(box => showDeleteConfirm(box))}
                    />
                  </Col>
                </Row>
              </div>
            </AnimatedTabs>
          </Col>
        </Row>
        <DeleteModal
          title="Eliminar PreAlerta"
          toogle={toogleModal}
          isOpen={isModalOpen}
          onDelete={() => { deleteBox(toDeleteBox) }}>
          Esta seguro que desea eliminar esta Prealerta?
        </DeleteModal>
      </Container>
    </>
  );
}

export default UserPackages;
